module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAABR0lEQVQokWNgQAIayx5Fai5/tAsZay9/EsKAEzT8Z0LXgI6x6iOkSXP5o10ayx/tRNW04nEKMRo1lz/apb7iqT9JtmF1Ms00Gi6+tWdjTPJjGP5qoVYF1fhwMz6NyJq2RCfc+2qlNvOrlXomg8raJzK4NLlPO3oIWeMbB70FEI1qMxkYGBgY1Jc97Mem0XfeuUvrU/LebkjMfHkoNPQMTBNcIwMDA4PG0sc5yJpMtn26YbLt040NqQXvd8en3D4VGXYMpumLlVoxRmJQX/bYw3jbp3VmO79ustjzY2rYxoeVpyLDjp2KDDt2y8dl8zcrtQ6cKdD2yP8CbNj+8P883OmWgYHB7vD/bGwarY/8D8Kr0Xzbfz5sGhka/jOhqtweoICu2WH/fwH7w//zbI/8L7A7/D/b+Mx/VkwrtgeuYtjhb4vXGWgAAFuDfoFvEAdBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/p4345.png
// module id = vfTa
// module chunks = 2